// Placeholder shown in the sync-center until real video thumbnails are generated.
// Inline data URI so it needs no network round-trip or bundled asset.
export const VIDEO_UPLOAD_PLACEHOLDER_THUMBNAIL =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">` +
      `<rect width="48" height="48" fill="#e5e7eb"/>` +
      `<path d="M20 17v14l11-7z" fill="#9ca3af"/>` +
      `</svg>`,
  );
